import TimeSingle from './single';
import TimeRange from './range';
import TimeRangeChk from './rangeChk';

class TimeList{}

TimeList.Single = TimeSingle;
TimeList.Range = TimeRange;
TimeList.RangeChk = TimeRangeChk;
export default TimeList;


// WEBPACK FOOTER //
// ./src/components/timelist/index.js